import React from 'react';

export const VersionPackage = () => {

  return (
    <span>
      v{process.env.VERSION}
    </span>
  )
}



// WEBPACK FOOTER //
// ./source/client/components/common/versionPackage.jsx